import type { Nullish } from "~/@types/generics"
import { SORT_BY_SUFFIXES } from "~/lib/algolia/constants"
import type { SortBy } from "~/lib/algolia/types"

export function isReplicaSuffix(suffix: Nullish<SortBy>): suffix is SortBy {
  if (!suffix) return false
  return SORT_BY_SUFFIXES?.includes(suffix)
}
